import React, { useEffect, useState } from 'react'

import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import Tables from '../../../Components/Tables/Table'
import Paginations from '../../../Components/Pagination/Paginations'
import SearchBar from '../../../Components/SearchBar/SearchBar'
import Modal from '@mui/material/Modal'
import TableStickyHeader from '../../../Components/Tables/TableStickyHeader'
import moment from 'moment'

export default function LastTransactions ({
    rows,
    headers,
    labels,
    lastTransactionsHeaders,
    lastTransactionsLabels,
    lastTransactionsRows,
    openModalSummary,
    setOpenModalSummary,
    rowsInfo,
    search,
    setSearch,
    downloadExcel,
    downloadPdf
}){    
    const [page, setPage] = useState(0);
    const [pageModal, setPageModal] = useState(0);
    const [currentTransactions, setCurrentTransactions] = useState(rows);
    const [currentTransactionsInfo, setCurrentTransactionsInfo] = useState(rowsInfo);
    const [currentLastTransactions, setCurrentLastTransactions] = useState(lastTransactionsRows);
    const [headersInfo, setHeadersInfo] = useState(['Tasa (%)', 'Monto disponible ($)']);
    const [labelsInfo, setLabelsInfo] = useState(['rate', 'availableAmount']);
    const [searchAgain, setSearchAgain] = useState(false);

    useEffect(() => {
        if (search) {
            setPage(0);
            setCurrentTransactions(rows.filter((element) => {
                return element.payingName.toLocaleLowerCase().includes(search.toLocaleLowerCase())
            }));
            setCurrentLastTransactions(lastTransactionsRows.filter((element) => {
                return element.payerName.props.children.toLocaleLowerCase().includes(search.toLocaleLowerCase())
            }));
        } else {
            setCurrentTransactions(rows);
            setCurrentLastTransactions(lastTransactionsRows);
        }
    }, [search, searchAgain]);

    useEffect(() => {
        setCurrentTransactions(rows);
        setCurrentLastTransactions(lastTransactionsRows);
        if (search !== '') {
            setSearchAgain(!searchAgain);
        } else {
            setSearch('');
        }
    }, [rows, lastTransactionsRows]);

    useEffect(() => {
        setCurrentTransactionsInfo(rowsInfo);
    }, [rowsInfo]);

    const handleDownloadExcelTransacciones = () => {
        let title = 'Últimas Transacciones';
        let headerRow = {};
        lastTransactionsHeaders.map(e =>  {
            let element = {};
            element[e] = e 
            headerRow = {...headerRow, ...element}
            return element;
        });
        
        const dataRows = [];
        currentLastTransactions.map((object) => {
            dataRows.push({
                date: object.date.props.children,
                payerName: object.payerName.props.children,
                fee: object.fee.props.children,
                amount: object.amount.props.children
            })
            return dataRows;
        });
   
        downloadExcel(title, headerRow, dataRows);
    }

    const handleDownloadPdfTransacciones = () => {
        let title = 'Últimas Transacciones';
        let headerRow = {};
        lastTransactionsHeaders.map(e =>  {
            let element = {};
            element[e] = e 
            headerRow = {...headerRow, ...element}
            return element;
        });
        
        const dataRows = [];
        currentLastTransactions.map((object) => {
            dataRows.push({
                date: object.date.props.children,
                payerName: object.payerName.props.children,
                fee: object.fee.props.children,
                amount: object.amount.props.children
            })
            return dataRows;
        });

        downloadPdf(title, headerRow, dataRows);
    }

    const handleDownloadExcelPosturas = () => {
        let title = 'Mis ofertas';
        let newHeaders = headers.splice(0, headers.length - 1)
        let headerRow = {};
        newHeaders.map(e =>  {
            let element = {};
            element[e] = e 
            headerRow = {...headerRow, ...element}
            return element;
        });
        
        const dataRows = [];
        currentTransactions.map((object) => {
            dataRows.push({
                payingName: object.payingName,
                minRate: typeof object.minRate === typeof object ? object.minRate.props.children : object.minRate,
                availableAmount: typeof object.availableAmount === typeof object ? object.availableAmount.props.children : object.availableAmount,
            })
            return dataRows;
        });
   
        downloadExcel(title, headerRow, dataRows);
    }

    const handleDownloadPdfPosturas = () => {
        let title = 'Mis ofertas';
        let newHeaders = headers.splice(0, headers.length - 1)
        let headerRow = {};
        newHeaders.map(e =>  {
            let element = {};
            element[e] = e 
            headerRow = {...headerRow, ...element}
            return element;
        });
        
        const dataRows = [];
        currentTransactions.map((object) => {
            dataRows.push({
                payingName: object.payingName,
                minRate: typeof object.minRate === typeof object ? object.minRate.props.children : object.minRate,
                availableAmount: typeof object.availableAmount === typeof object ? object.availableAmount.props.children : object.availableAmount,
            })
            return dataRows;
        });

        downloadPdf(title, headerRow, dataRows);
    }

    const handleDownloadExcelModal = () => {
        let title = 'Competencia de tasas ' + rowsInfo[0]["payerName"] + ' ' + moment().format('DD-MM-yyyy HH:mm:ss');
        let headerRow = {};
        headersInfo.map(e =>  {
            let element = {};
            element[e] = e 
            headerRow = {...headerRow, ...element}
            return element;
        });
        
        const dataRows = [];
        rowsInfo.map((object) => {
            dataRows.push({
                rate: typeof object.rate === typeof object ? object.rate.props.children : object.rate,
                availableAmount:  typeof object.availableAmount === typeof object ? object.availableAmount.props.children : object.availableAmount,
            })
            return dataRows;
        });
   
        downloadExcel(title, headerRow, dataRows);
    }

    const handleDownloadPdfModal = () => {
        let title = 'Competencia de tasas ' + rowsInfo[0]["payerName"] + ' ' + moment().format('DD-MM-yyyy HH:mm:ss');
        let headerRow = {};
        headersInfo.map(e =>  {
            let element = {};
            element[e] = e 
            headerRow = {...headerRow, ...element}
            return element;
        });
        
        const dataRows = [];
        rowsInfo.map((object) => {
            dataRows.push({
                rate: typeof object.rate === typeof object ? object.rate.props.children : object.rate,
                availableAmount:  typeof object.availableAmount === typeof object ? object.availableAmount.props.children : object.availableAmount,
            })
            return dataRows;
        });

        downloadPdf(title, headerRow, dataRows);
    }

    

    return (
        <>
            <Grid
            item
            xs={12}
            sx={{
                display: "flex",
                justifyContent: "center",
                position: "relative",
            }}
            >
                <Grid item xs={12} className='buttons-container'>
                    <SearchBar
                        search={search}
                        setSearch={setSearch}
                    ></SearchBar>
                </Grid>
            </Grid>
            <Grid
                item
                xs={4}
                style={{
                    overflow: "auto",
                    marginTop: "20px",
                    marginRight: "10px",
                    maxHeight: "80vh"
                }}
            >
                <Grid item xs={12} className='buttons-container'>
                    <Button onClick={handleDownloadExcelTransacciones}
                        variant='contained'
                        color='buttonColor'
                    >
                        Descargar Excel
                    </Button>
                    <Button onClick={handleDownloadPdfTransacciones}
                        variant='contained'
                        color='buttonColor'>
                        Descargar PDF
                    </Button>
                </Grid>
                <Typography variant="h5" fontWeight={600}>
                    Últimas Transacciones
                </Typography>
                <Card style={{ padding: "10px 20px", marginTop: "20px" }}>
                    <Grid container>
                        <Grid item xs={12}>
                            <TableStickyHeader
                                minWidth={200}
                                rows={currentLastTransactions}
                                headers={lastTransactionsHeaders}
                                labels={lastTransactionsLabels}
                            />
                        </Grid>
                    </Grid>
                </Card>
            </Grid>
            <Grid
                item
                xs={7}
                style={{
                    overflow: "auto",
                    marginTop: "20px",
                    marginLeft: "10px",
                    maxHeight: "80vh"
                }}
            >
                <Grid item xs={12} className='buttons-container'>
                    <Button onClick={handleDownloadExcelPosturas}
                        variant='contained'
                        color='buttonColor'
                    >
                        Descargar Excel
                    </Button>
                    <Button onClick={handleDownloadPdfPosturas}
                        variant='contained'
                        color='buttonColor'>
                        Descargar PDF
                    </Button>
                </Grid>
                <Typography variant="h5" fontWeight={600}>
                    Ofertas del mercado
                </Typography>
                <Card style={{ padding: "10px 20px", marginTop: "20px" }}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Tables
                                rows={currentTransactions.slice((page * 14), (page * 14) + 14)}
                                headers={headers}
                                labels={labels}
                            />
                        </Grid>
                    </Grid>
                </Card>
                <Box display="flex" justifyContent="end" marginTop="20px" width='100%'>
                    <Paginations
                        onChange={(event, val) => { setPage(val - 1) }}
                        count={Math.ceil(currentTransactions.length / 14)}
                    />
                </Box>
            </Grid>
         

            <Modal
                open={openModalSummary}
                onClose={() => {
                    setPageModal(0)
                    setOpenModalSummary(false)
                }}
            >
                <Box className='payingSummary-modal'>
                    <Grid container>
                        <Grid item xs={12} className='buttons-container'>
                            <Button onClick={handleDownloadExcelModal}
                                variant='contained'
                                color='buttonColor'
                            >
                                Descargar Excel
                            </Button>
                            <Button onClick={handleDownloadPdfModal}
                                variant='contained'
                                color='buttonColor'>
                                Descargar PDF
                            </Button>
                        </Grid>
                        <Typography variant="h5" fontWeight={600} sx={{ marginBottom: 2 }}>
                            Competencia de tasas
                        </Typography>
                        <Grid item xs={12}>
                            <Tables
                                rows={currentTransactionsInfo.slice((pageModal * 10), (pageModal * 10) + 10)}
                                headers={headersInfo}
                                labels={labelsInfo}
                            />
                        </Grid>
                    </Grid>
                    <Box display="flex" justifyContent="end" marginTop="20px" width='100%'>
                        <Paginations
                            onChange={(event, val) => { setPageModal(val - 1) }}
                            count={Math.ceil(currentTransactionsInfo.length / 10)}
                        />
                    </Box>
                </Box>
            </Modal>
        </>
    )
}